import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectPropertyDamageStep = (state) => state.get('propertyDamageStep');

const makeSelectPropertyDamageStep = () => createSelector(
  selectPropertyDamageStep,
  (stepPropertyDamageState) => ({
    areYouClaimingForPropertyDamage: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'areYouClaimingForPropertyDamage']),
      ''
    ),
    companyName: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'companyName']),
      ''
    ),
    schoolName: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'schoolName']),
      ''
    ),
    address: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'address']),
      ''
    ),
    cityOrTown: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'cityOrTown']),
      ''
    ),
    state: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'state']),
      ''
    ),
    postalCode: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'postalCode']),
      ''
    ),
    ifYesNameOfPhysicianCurrentlyTreatingThis: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'ifYesNameOfPhysicianCurrentlyTreatingThis']),
      ''
    ),
    contact: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'contact']),
      ''
    ),
    phoneNumber: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'phoneNumber']),
      ''
    ),
    companyNameForOther: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'companyNameForOther']),
      ''
    ),
    addressForOther: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'addressForOther']),
      ''
    ),
    typeOfPolicyForOther: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'typeOfPolicyForOther']),
      ''
    ),
    policyForOther: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'policyForOther']),
      ''
    ),
    contactForOther: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'contactForOther']),
      ''
    ),
    phoneForOther: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'phoneForOther']),
      ''
    ),
    cityOrTownForOther: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'cityOrTownForOther']),
      ''
    ),
    countryForOther: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'countryForOther']),
      ''
    ),
    postalCodeForOther: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'postalCodeForOther']),
      ''
    ),
    origination: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'origination']),
      ''
    ),
    flightNumberOrigination: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'flightNumberOrigination']),
      ''
    ),
    airCarrierOrigination: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'airCarrierOrigination']),
      ''
    ),
    destination: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'destination']),
      ''
    ),
    flightNumberDestination: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'flightNumberDestination']),
      ''
    ),
    airCarrierDestination: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'airCarrierDestination']),
      ''
    ),
    propertyName: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'propertyName']),
      ''
    ),
    propertyAddress: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'propertyAddress']),
      ''
    ),
    propertyCityOrTown: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'propertyCityOrTown']),
      ''
    ),
    propertyCountry: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'propertyCountry']),
      ''
    ),
    propertyPostalCode: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'propertyPostalCode']),
      ''
    ),
    unitOwnerName: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'unitOwnerName']),
      ''
    ),
    unitTelephoneNumber: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'unitTelephoneNumber']),
      ''
    ),
    numberOfPeopleInUnit: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'numberOfPeopleInUnit']),
      ''
    ),
    describeIndicentThatCausedTheDamage: mapWithDefault(
      stepPropertyDamageState,
      () => stepPropertyDamageState.getIn(['form', 'describeIndicentThatCausedTheDamage']),
      ''
    ),
    expenseDescriptionOfItems: mapWithDefault(stepPropertyDamageState, () => stepPropertyDamageState.getIn(['form', 'expenseDescriptionOfItems']) && stepPropertyDamageState.getIn(['form', 'expenseDescriptionOfItems']).toJS(), ''),
  })
);

const makeSelectPropertyDamageStepErrors = () =>
  createSelector(selectPropertyDamageStep, (state) => state.get('errors'));

export {
  makeSelectPropertyDamageStep,
  makeSelectPropertyDamageStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.PropertyDamageStep/selectors.js